import React, { Fragment } from 'react';
import usePageSeo from '../../hooks/usePageSeo';
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import LowVoltageRequest from '../../components/LowVoltageRequest/LowVoltageRequest';

const STEPS = [
    { n: '1', t: 'You tell us the project', d: 'Units, building type, systems needed, and a site plan — the basics we need to scope real design work.' },
    { n: '2', t: 'We check the ISP side', d: "If there's an ISP agreement in play, we review the marketing terms and confirm every infrastructure cost is clearly assigned before you sign." },
    { n: '3', t: 'You get a proposal', d: 'A scoped design + install proposal for structured cabling, Wi-Fi, security, DAS/ERRCS, and life-safety systems — tailored to the site plan.' },
];

const css = `
.lvp *{box-sizing:border-box}
.lvp__wrap{max-width:900px;margin:0 auto;padding:0 clamp(16px,4vw,26px)}
.lvp__lead{text-align:center;max-width:760px;margin:0 auto;padding:clamp(30px,5vw,54px) 0 4px}
.lvp__k{font-family:'Axiforma Bold',sans-serif;color:#0044EB;font-size:13px;letter-spacing:2.4px;text-transform:uppercase}
.lvp__h2{font-family:'Axiforma Bold',sans-serif;color:#020842;font-size:clamp(26px,4.6vw,40px);line-height:1.1;margin:12px 0 0}
.lvp__sub{font-family:'Axiforma Regular',sans-serif;color:#54648A;font-size:clamp(15px,2.2vw,18px);line-height:1.55;margin:16px 0 0}
.lvp__steps{display:grid;grid-template-columns:repeat(3,1fr);gap:18px;margin:clamp(28px,4vw,44px) 0}
.lvp__step{background:#F1F6FC;border-radius:14px;padding:20px}
.lvp__sn{width:34px;height:34px;border-radius:10px;background:#020842;color:#fff;font-family:'Axiforma Bold',sans-serif;font-size:15px;display:flex;align-items:center;justify-content:center}
.lvp__st{font-family:'Axiforma Bold',sans-serif;color:#020842;font-size:16.5px;margin:12px 0 6px}
.lvp__sd{font-family:'Axiforma Regular',sans-serif;color:#54648A;font-size:13.5px;line-height:1.5;margin:0}
@media(max-width:760px){.lvp__steps{grid-template-columns:1fr}}
`;

const LowVoltageRequestPage = () => {
    usePageSeo({
        title: 'Request a Low-Voltage Design & Install Proposal',
        description:
            'Request a low-voltage design and install proposal for your multifamily, affordable housing, or commercial project — with expert ISP agreement review included.',
        keywords:
            'low voltage design build, structured cabling proposal, multifamily low voltage contractor, ISP marketing agreement review, MDU broadband agreement, DAS ERRCS proposal, low voltage RFP, California low voltage installer, BUILDLAB',
    });

    return (
        <Fragment>
            <Header />
            <main className="page_content lvp">
                <style dangerouslySetInnerHTML={{ __html: css }} />
                <PageTitle pageTitle={'Low-Voltage Project Request'} pagesub={'Design & Install'} pageTop={'Get a Proposal'} />

                <section style={{ background: '#fff' }}>
                    <div className="lvp__wrap">
                        <div className="lvp__lead">
                            <div className="lvp__k">Design-build low-voltage</div>
                            <h2 className="lvp__h2">Tell us about the project — we'll take it from there</h2>
                            <p className="lvp__sub">
                                Structured cabling, resident Wi-Fi, security, DAS/ERRCS and life-safety systems — scoped and
                                priced from your actual project details. Fill in what you know, attach a site plan, and we'll
                                turn around a proposal.
                            </p>
                        </div>
                        <div className="lvp__steps">
                            {STEPS.map((s) => (
                                <div key={s.n} className="lvp__step">
                                    <div className="lvp__sn">{s.n}</div>
                                    <div className="lvp__st">{s.t}</div>
                                    <p className="lvp__sd">{s.d}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section style={{ background: '#fff', paddingBottom: 'clamp(30px,5vw,56px)' }}>
                    <div className="lvp__wrap">
                        <LowVoltageRequest />
                    </div>
                </section>

                <CtaSection />
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default LowVoltageRequestPage;
